import { useEffect } from 'react';

/**
 * @name useControlSection
 * @description Custom hook to manage control section sync logic.
 * Syncs expSectionName based on the selected control section and split type,
 * and derives a warning flag when the user-selected section differs from the detected live section.
 *
 * @param {Object} options - Hook options
 * @param {Object} options.units - Map of section refs to unit objects
 * @param {string} options.controlsectionRef - Currently selected control section ref
 * @param {string} options.detectedLiveSectionRef - Auto-detected live section ref
 * @param {Function} options.setExpSectionName - State setter for experiment section name
 *
 * @returns {Object} { showDefaultControlSectionMismatchWarning }
 * @returns {boolean} .showDefaultControlSectionMismatchWarning - True when selected section differs from detected live section
 */
const useControlSection = ({
	units,
	controlsectionRef,
	detectedLiveSectionRef,
	setExpSectionName
}) => {
	// Warns when user manually selects a different section than the auto-detected live section
	const showDefaultControlSectionMismatchWarning =
		detectedLiveSectionRef && controlsectionRef && controlsectionRef !== detectedLiveSectionRef;

	// Syncs expSectionName: sets unit name for control section
	useEffect(() => {
		if (!controlsectionRef || !units[controlsectionRef]) {
			setExpSectionName('');
			return;
		}

		setExpSectionName(units[controlsectionRef].name);
	}, [controlsectionRef]);

	return {
		showDefaultControlSectionMismatchWarning
	};
};

export default useControlSection;
